import { TableCell, withStyles } from '@material-ui/core';

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#283242',
        color: theme.palette.common.white,
        padding: '5px'
    },
    body: {
        fontSize: 14,
        padding: '0px 2px 10px 2px ',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);

export const HeadingTableCell = withStyles((theme) => ({
    head: {
        padding: '0px 2px',
        border: 'none'
        // border: '1px solid rgba(0,0,0,0.04)'
    },
    body: {
        padding: '0px 2px 3px 2px',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);
